<template>
    <div class="selector-box">
        <div class="title-part">
            <span tkey="香港地圖">{{i18n.tkey("lang_hongkong_map")}}</span>
        </div>

        <div
            class="close-part"
            @click="clickClose"
            v-show="false !== showClose"
        >
            <font-awesome-icon icon="fa-solid fa-xmark" />
        </div>

        <div class="selector-part">
            <HongKongCodeSelector
                @select-complete="selectCallback"
            />
			       
        </div>

        <div class="map-part">
            <HongKongMap
                @select-complete="selectCallback"
            />
        </div>
		<div style="position: relative;width: 100%;z-index: 12;position: absolute;bottom: 20px;">
		    <confirmButton class="click-btn" @click="clickGoHongkong" tkey="前往香港">{{i18n.tkey("lang_go_hongkong")}}</confirmButton>
		    
		</div>
		
    </div>
</template>

<script setup>

import HongKongMap from "@/components/shopopee/map/HongKongMap.vue";
import HongKongCodeSelector from "@/components/shopopee/country/HongKongCodeSelector.vue";
import confirmButton from "@/components/Shopopee3D/ui/confirmButton"
//导入图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import {inject, toRef} from "vue";
import {useUserinfo} from "@/stores/userinfo";
library.add(faXmark)

const props = defineProps(["codeList", "showClose"])
const emits = defineEmits(["select-complete", "clickClose"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

function selectCallback(obj){
    emits("select-complete", obj)
}

function clickGoHongkong(){
	var obj = {code:""}
	emits("select-complete", obj)
}

function clickClose(){
    emits("clickClose")
}

</script>

<style scoped>

.selector-box {
    width: 100%;
    height: 100%;
    position: relative;
    background: linear-gradient(to bottom, #F7E5BF 0%, #EBEBEB 100%);
    opacity: 1;
    animation: show-background 0.5s ease-out;
    overflow: hidden;
}

@keyframes show-background {

    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }

}

.title-part {
    text-align: center;
    line-height: 2;
    font-weight: 600;
    font-size: 24px;
}

.close-part {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
    position: absolute;
    top: 10px;
    right: 10px;
}

@media screen and (max-width: 768px) {
    .map-part {
        width: 130%;
        height: calc(100% - 50px);
        position: relative;
        left: -12%;
        //top: -180px;
        z-index: 9;
    }
}

@media screen and (min-width: 768px) {
    .map-part {
        width: 100%;
        height: calc(100% - 50px);
        position: relative;
        top: -50px;
        z-index: 9;
    }
}

.selector-part {
    text-align: center;
    position: relative;
    z-index: 10;
}

</style>